// Health Signals Assessment — question bank (50 items + priorities)
// Source of truth: AAA-kkl-health-quiz-question-bank.xlsx (Simplified for cognitive ease)
window.KKL_QUIZ_DATA = {
  dimensions: {
    gut:      { label: 'Gut' },
    vessel:   { label: 'Vessel' },
    sleep:    { label: 'Sleep' },
    muscle:   { label: 'Muscle' },
    vitamins: { label: 'Vitamins' }
  },
  priorities: [
    { dim: 'gut',      label: 'Digestion & gut comfort' },
    { dim: 'vessel',   label: 'Energy & circulation' },
    { dim: 'sleep',    label: 'Sleep quality' },
    { dim: 'muscle',   label: 'Strength & muscle tone' },
    { dim: 'vitamins', label: 'Skin, hair & overall vitality' }
  ],
  selection: { total: 10, allocation: [4, 3, 3] },
  questions: [
    {
      id: 'G1',
      dim: 'gut',
      rank: 1,
      text: 'How often do you experience irregular bowel movements?',
      options: [
        { label: 'Rarely', score: 0 },
        { label: 'Occasionally', score: 1 },
        { label: 'Often', score: 2 },
        { label: 'Almost daily', score: 3 }
      ]
    },
    {
      id: 'G2',
      dim: 'gut',
      rank: 2,
      text: 'Do you feel bloated or gassy after eating?',
      options: [
        { label: 'Rarely', score: 0 },
        { label: 'Occasionally', score: 1 },
        { label: 'Often', score: 2 },
        { label: 'Almost daily', score: 3 }
      ]
    },
    {
      id: 'G3',
      dim: 'gut',
      rank: 3,
      text: 'Do you experience acid reflux or heartburn?',
      options: [
        { label: 'Rarely', score: 0 },
        { label: 'Occasionally', score: 1 },
        { label: 'Often', score: 2 },
        { label: 'Almost daily', score: 3 }
      ]
    },
    {
      id: 'G9',
      dim: 'gut',
      rank: 4,
      text: 'Describe your typical stool consistency.',
      options: [
        { label: 'Soft, smooth & well-formed', score: 0 },
        { label: 'Mildly hard or slightly loose', score: 1 },
        { label: 'Hard pellets or watery', score: 2 },
        { label: 'Alternating between hard and loose', score: 3 }
      ]
    },
    {
      id: 'G6',
      dim: 'gut',
      rank: 5,
      text: 'How frequent are your bowel movements?',
      options: [
        { label: 'Daily or more', score: 0 },
        { label: 'Most days', score: 1 },
        { label: 'A few times a week', score: 2 },
        { label: 'Less than 3 times a week', score: 3 }
      ]
    },
    {
      id: 'G4',
      dim: 'gut',
      rank: 6,
      text: 'Do specific foods trigger digestive or skin sensitivities?',
      options: [
        { label: 'Rarely', score: 0 },
        { label: 'Occasionally', score: 1 },
        { label: 'Often', score: 2 },
        { label: 'Almost daily', score: 3 }
      ]
    },
    {
      id: 'G7',
      dim: 'gut',
      rank: 7,
      text: 'Does stress affect your digestive comfort?',
      options: [
        { label: 'Rarely', score: 0 },
        { label: 'Occasionally', score: 1 },
        { label: 'Often', score: 2 },
        { label: 'Almost daily', score: 3 }
      ]
    },
    {
      id: 'G10',
      dim: 'gut',
      rank: 8,
      text: 'Do you feel abdominal heaviness without large meals?',
      options: [
        { label: 'Rarely', score: 0 },
        { label: 'Occasionally', score: 1 },
        { label: 'Often', score: 2 },
        { label: 'Almost daily', score: 3 }
      ]
    },
    {
      id: 'G8',
      dim: 'gut',
      rank: 9,
      text: 'How many glasses of water do you drink daily?',
      options: [
        { label: '8 or more', score: 0 },
        { label: '5-7', score: 1 },
        { label: '3-4', score: 2 },
        { label: 'Fewer than 3', score: 3 }
      ]
    },
    {
      id: 'G5',
      dim: 'gut',
      rank: 10,
      text: 'How often do you maintain an irregular meal schedule?',
      options: [
        { label: 'Rarely', score: 0 },
        { label: 'Occasionally', score: 1 },
        { label: 'Often', score: 2 },
        { label: 'Almost daily', score: 3 }
      ]
    },
    {
      id: 'V3',
      dim: 'vessel',
      rank: 1,
      text: 'Any elevated markers in your recent health check?',
      options: [
        { label: 'None', score: 0 },
        { label: 'One', score: 1 },
        { label: 'Two', score: 2 },
        { label: 'Three or more', score: 3 }
      ]
    },
    {
      id: 'V1',
      dim: 'vessel',
      rank: 2,
      text: 'Do you feel dizzy when standing up quickly?',
      options: [
        { label: 'Rarely', score: 0 },
        { label: 'Occasionally', score: 1 },
        { label: 'Often', score: 2 },
        { label: 'Almost daily', score: 3 }
      ]
    },
    {
      id: 'V2',
      dim: 'vessel',
      rank: 3,
      text: 'Do your extremities often feel cold or numb?',
      options: [
        { label: 'Rarely', score: 0 },
        { label: 'Occasionally', score: 1 },
        { label: 'Often', score: 2 },
        { label: 'Almost daily', score: 3 }
      ]
    },
    {
      id: 'V9',
      dim: 'vessel',
      rank: 4,
      text: 'Any family history of cardiovascular concerns?',
      options: [
        { label: 'None', score: 0 },
        { label: 'One', score: 1 },
        { label: 'Two', score: 2 },
        { label: 'Three or more', score: 3 }
      ]
    },
    {
      id: 'V6',
      dim: 'vessel',
      rank: 5,
      text: 'Do you notice a racing or pounding heartbeat?',
      options: [
        { label: 'Rarely', score: 0 },
        { label: 'Occasionally', score: 1 },
        { label: 'Often', score: 2 },
        { label: 'Almost daily', score: 3 }
      ]
    },
    {
      id: 'V4',
      dim: 'vessel',
      rank: 6,
      text: 'Do you notice leg swelling after long sitting?',
      options: [
        { label: 'Rarely', score: 0 },
        { label: 'Occasionally', score: 1 },
        { label: 'Often', score: 2 },
        { label: 'Almost daily', score: 3 }
      ]
    },
    {
      id: 'V7',
      dim: 'vessel',
      rank: 7,
      text: 'How often do you consume processed or salty foods?',
      options: [
        { label: 'Rarely', score: 0 },
        { label: 'Occasionally', score: 1 },
        { label: 'Often', score: 2 },
        { label: 'Almost daily', score: 3 }
      ]
    },
    {
      id: 'V8',
      dim: 'vessel',
      rank: 8,
      text: 'How many days per week are you active?',
      options: [
        { label: '5 or more days', score: 0 },
        { label: '3-4 days', score: 1 },
        { label: '1-2 days', score: 2 },
        { label: 'Rarely', score: 3 }
      ]
    },
    {
      id: 'V5',
      dim: 'vessel',
      rank: 9,
      text: 'How frequently do you experience headaches?',
      options: [
        { label: 'Rarely', score: 0 },
        { label: 'Occasionally', score: 1 },
        { label: 'Often', score: 2 },
        { label: 'Almost daily', score: 3 }
      ]
    },
    {
      id: 'V10',
      dim: 'vessel',
      rank: 10,
      text: 'How often do you consume alcohol or smoke?',
      options: [
        { label: 'Never', score: 0 },
        { label: 'Occasionally', score: 1 },
        { label: 'Most days', score: 2 },
        { label: 'Daily', score: 3 }
      ]
    },
    {
      id: 'S1',
      dim: 'sleep',
      rank: 1,
      text: 'How long does it take you to fall asleep?',
      options: [
        { label: 'Under 15 min', score: 0 },
        { label: '15-30 min', score: 1 },
        { label: '30-60 min', score: 2 },
        { label: 'Over 60 min', score: 3 }
      ]
    },
    {
      id: 'S2',
      dim: 'sleep',
      rank: 2,
      text: 'How many times do you wake up at night?',
      options: [
        { label: 'Never', score: 0 },
        { label: 'Once', score: 1 },
        { label: 'Twice', score: 2 },
        { label: 'Three or more', score: 3 }
      ]
    },
    {
      id: 'S4',
      dim: 'sleep',
      rank: 3,
      text: 'Do you wake up feeling unrefreshed or tired?',
      options: [
        { label: 'Rarely', score: 0 },
        { label: 'Occasionally', score: 1 },
        { label: 'Often', score: 2 },
        { label: 'Almost daily', score: 3 }
      ]
    },
    {
      id: 'S3',
      dim: 'sleep',
      rank: 4,
      text: 'Do you struggle to fall back asleep after waking?',
      options: [
        { label: 'Rarely', score: 0 },
        { label: 'Occasionally', score: 1 },
        { label: 'Often', score: 2 },
        { label: 'Almost daily', score: 3 }
      ]
    },
    {
      id: 'S9',
      dim: 'sleep',
      rank: 5,
      text: 'Do you feel mentally \'wired\' at bedtime?',
      options: [
        { label: 'Rarely', score: 0 },
        { label: 'Occasionally', score: 1 },
        { label: 'Often', score: 2 },
        { label: 'Almost daily', score: 3 }
      ]
    },
    {
      id: 'S8',
      dim: 'sleep',
      rank: 6,
      text: 'Have you been told you snore loudly?',
      options: [
        { label: 'Never', score: 0 },
        { label: 'Rarely', score: 1 },
        { label: 'Occasionally', score: 2 },
        { label: 'Often', score: 3 }
      ]
    },
    {
      id: 'S10',
      dim: 'sleep',
      rank: 7,
      text: 'Do you rely on sleep aids or alcohol?',
      options: [
        { label: 'Never', score: 0 },
        { label: 'Occasionally', score: 1 },
        { label: 'Several times a week', score: 2 },
        { label: 'Almost every night', score: 3 }
      ]
    },
    {
      id: 'S5',
      dim: 'sleep',
      rank: 8,
      text: 'How consistent is your daily sleep schedule?',
      options: [
        { label: 'Almost every day', score: 0 },
        { label: 'Most days', score: 1 },
        { label: 'Occasionally', score: 2 },
        { label: 'Rarely', score: 3 }
      ]
    },
    {
      id: 'S7',
      dim: 'sleep',
      rank: 9,
      text: 'Do you consume caffeine in the afternoon?',
      options: [
        { label: 'Rarely', score: 0 },
        { label: 'Occasionally', score: 1 },
        { label: 'Often', score: 2 },
        { label: 'Almost daily', score: 3 }
      ]
    },
    {
      id: 'S6',
      dim: 'sleep',
      rank: 10,
      text: 'Do you use screens within an hour of bedtime?',
      options: [
        { label: 'Rarely', score: 0 },
        { label: 'Occasionally', score: 1 },
        { label: 'Often', score: 2 },
        { label: 'Almost every night', score: 3 }
      ]
    },
    {
      id: 'M3',
      dim: 'muscle',
      rank: 1,
      text: 'Do you experience muscle weakness or joint stiffness?',
      options: [
        { label: 'Rarely', score: 0 },
        { label: 'Occasionally', score: 1 },
        { label: 'Often', score: 2 },
        { label: 'Almost daily', score: 3 }
      ]
    },
    {
      id: 'M1',
      dim: 'muscle',
      rank: 2,
      text: 'How many days per week do you strength train?',
      options: [
        { label: '3 or more days', score: 0 },
        { label: '1-2 days', score: 1 },
        { label: 'Rarely', score: 2 },
        { label: 'Never', score: 3 }
      ]
    },
    {
      id: 'M2',
      dim: 'muscle',
      rank: 3,
      text: 'How many meals include a solid protein source?',
      options: [
        { label: '3 or more meals', score: 0 },
        { label: '2 meals', score: 1 },
        { label: '1 meal', score: 2 },
        { label: 'Rarely', score: 3 }
      ]
    },
    {
      id: 'M4',
      dim: 'muscle',
      rank: 4,
      text: 'How long is your recovery after physical exertion?',
      options: [
        { label: 'Within a day', score: 0 },
        { label: '1-2 days', score: 1 },
        { label: '2-3 days', score: 2 },
        { label: 'Longer than 3 days', score: 3 }
      ]
    },
    {
      id: 'M6',
      dim: 'muscle',
      rank: 5,
      text: 'Do you feel unsteady or notice balance issues?',
      options: [
        { label: 'Rarely', score: 0 },
        { label: 'Occasionally', score: 1 },
        { label: 'Often', score: 2 },
        { label: 'Almost daily', score: 3 }
      ]
    },
    {
      id: 'M9',
      dim: 'muscle',
      rank: 6,
      text: 'Have you noticed your grip strength weakening?',
      options: [
        { label: 'Rarely', score: 0 },
        { label: 'Occasionally', score: 1 },
        { label: 'Often', score: 2 },
        { label: 'Almost daily', score: 3 }
      ]
    },
    {
      id: 'M7',
      dim: 'muscle',
      rank: 7,
      text: 'Do you experience muscle cramps or leg twitching?',
      options: [
        { label: 'Rarely', score: 0 },
        { label: 'Occasionally', score: 1 },
        { label: 'Often', score: 2 },
        { label: 'Almost daily', score: 3 }
      ]
    },
    {
      id: 'M10',
      dim: 'muscle',
      rank: 8,
      text: 'Do you experience lower-back tightness or aches?',
      options: [
        { label: 'Rarely', score: 0 },
        { label: 'Occasionally', score: 1 },
        { label: 'Often', score: 2 },
        { label: 'Almost daily', score: 3 }
      ]
    },
    {
      id: 'M8',
      dim: 'muscle',
      rank: 9,
      text: 'How often do you perform weight-bearing activities?',
      options: [
        { label: 'Almost daily', score: 0 },
        { label: 'Most days', score: 1 },
        { label: 'Occasionally', score: 2 },
        { label: 'Rarely', score: 3 }
      ]
    },
    {
      id: 'M5',
      dim: 'muscle',
      rank: 10,
      text: 'How many hours do you spend sitting daily?',
      options: [
        { label: 'Under 4 hours', score: 0 },
        { label: '4-6 hours', score: 1 },
        { label: '7-9 hours', score: 2 },
        { label: '10 hours or more', score: 3 }
      ]
    },
    {
      id: 'Vit1',
      dim: 'vitamins',
      rank: 1,
      text: 'How many servings of produce do you eat daily?',
      options: [
        { label: '5 or more servings', score: 0 },
        { label: '3-4 servings', score: 1 },
        { label: '1-2 servings', score: 2 },
        { label: 'Rarely', score: 3 }
      ]
    },
    {
      id: 'Vit2',
      dim: 'vitamins',
      rank: 2,
      text: 'How much daily time do you spend in daylight?',
      options: [
        { label: 'Over 2 hours', score: 0 },
        { label: '1-2 hours', score: 1 },
        { label: 'Under 1 hour', score: 2 },
        { label: 'Almost none', score: 3 }
      ]
    },
    {
      id: 'Vit7',
      dim: 'vitamins',
      rank: 3,
      text: 'How often do you rely on convenience foods?',
      options: [
        { label: 'Rarely', score: 0 },
        { label: 'Occasionally', score: 1 },
        { label: 'Often', score: 2 },
        { label: 'Almost daily', score: 3 }
      ]
    },
    {
      id: 'Vit3',
      dim: 'vitamins',
      rank: 4,
      text: 'Notice any dry skin, brittle nails, or shedding?',
      options: [
        { label: 'Rarely', score: 0 },
        { label: 'Occasionally', score: 1 },
        { label: 'Often', score: 2 },
        { label: 'Almost daily', score: 3 }
      ]
    },
    {
      id: 'Vit4',
      dim: 'vitamins',
      rank: 5,
      text: 'How often do you catch colds or feel run down?',
      options: [
        { label: 'Rarely', score: 0 },
        { label: 'Occasionally', score: 1 },
        { label: 'Often', score: 2 },
        { label: 'Almost daily', score: 3 }
      ]
    },
    {
      id: 'Vit8',
      dim: 'vitamins',
      rank: 6,
      text: 'Does your mood drop during cloudy or winter days?',
      options: [
        { label: 'Rarely', score: 0 },
        { label: 'Occasionally', score: 1 },
        { label: 'Often', score: 2 },
        { label: 'Almost always', score: 3 }
      ]
    },
    {
      id: 'Vit6',
      dim: 'vitamins',
      rank: 7,
      text: 'Do you consume fatty fish like salmon or mackerel?',
      options: [
        { label: '2+ times a week', score: 0 },
        { label: 'Once a week', score: 1 },
        { label: 'A few times a month', score: 2 },
        { label: 'Rarely or never', score: 3 }
      ]
    },
    {
      id: 'Vit5',
      dim: 'vitamins',
      rank: 8,
      text: 'How often do you eat animal-based proteins?',
      options: [
        { label: 'At most meals', score: 0 },
        { label: 'Daily', score: 1 },
        { label: 'A few times a week', score: 2 },
        { label: 'Rarely or never', score: 3 }
      ]
    },
    {
      id: 'Vit10',
      dim: 'vitamins',
      rank: 9,
      text: 'Is your daily diet missing key nutrients?',
      options: [
        { label: 'Rarely - my meals are balanced', score: 0 },
        { label: 'Occasionally', score: 1 },
        { label: 'Often', score: 2 },
        { label: 'Almost always - I know I don\'t eat well', score: 3 }
      ]
    },
    {
      id: 'Vit9',
      dim: 'vitamins',
      rank: 10,
      text: 'Any conditions affecting your nutrient absorption?',
      options: [
        { label: 'No', score: 0 },
        { label: 'Occasional antacid use', score: 1 },
        { label: 'Long-term antacid or PPI use', score: 2 },
        { label: 'Diagnosed absorption condition', score: 3 }
      ]
    }
  ]
};
